//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "../../services/api";
import { server } from "../../services/constants";

export default {
  methods: {
    onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },
    onClickMenuItem(link) {
      localStorage.setItem(server.MODELMENU, link.index);
      // alert(link);
      this.$router.push(link.route).catch((err) => {});
    },
  },
  async mounted() {
    this.$store.state.modelmenu = parseInt(
      localStorage.getItem(server.MODELMENU)
    );
    // let loader = this.$loading.show({
    //   // Optional parameters
    //   color: "green",
    //   loader: "dots",
    //   container: this.fullPage ? null : this.$refs.formContainer,
    //   canCancel: false,
    //   width: 120,
    //   height: 120,
    //   backgroundColor: "#ffffff",
    //   opacity: 0.5,
    //   zIndex: 999,
    //   onCancel: this.onCancel,
    // });

    //   alert("initialize");
    // const res_get = await api.getSettingGroupMenu();
    const res_get = await api.getListMenuDetailById(
      localStorage.getItem(server.AUTHORIZE_ID)
    );

    this.authorize = res_get.data;
    // console.log("authorize: " + JSON.stringify(this.authorize));
    // loader.hide();

    // check menu
    // 1.dashboard
    // 2.employee
    // 3.customer
    // 4.1 group-menu
    // 4.2 menu-detail
    // 4.3 setting-group-menu
    // 4.4 setting-menu-detail
    // 5.report
    // 6.1 so-list
    // 6.2 add-so
    // 7.1 advance-list
    // 7.2 new-advance

    this.authorize.forEach((item) => {
      // alert(item.cmd_route);

      // dashboard menu
      if (item.cmd_route == "dashboard" && item.smd_view == 1) {
        this.menus[0].items.push({
          index: 0,
          title: "Dashboard",
          route: "/dashboard",
        });
      }

      // if (item.cmd_route == "training-list" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 1,
      //     title: "Training",
      //     route: "/training-list",
      //   });
      // }
      // administrator menu
      // if (item.cmd_route == "company" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 1,
      //     title: "1.Company",
      //     route: "/company",
      //   });
      // }
      // if (item.cmd_route == "department" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 2,
      //     title: "2.Department",
      //     route: "/department",
      //   });
      // }
      // if (item.cmd_route == "position" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 3,
      //     title: "3.Position",
      //     route: "/position",
      //   });
      // }
      // if (item.cmd_route == "jobtitle" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 4,
      //     title: "4.Job Title",
      //     route: "/jobtitle",
      //   });
      // }
      // if (item.cmd_route == "leave-quota" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 5,
      //     title: "5.Leave Quota",
      //     route: "/leave-quota",
      //   });
      // }
      // if (item.cmd_route == "document-setup" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 6,
      //     title: "6.Document Setup",
      //     route: "/document-setup",
      //   });
      // }
      // if (item.cmd_route == "contact-list" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 7,
      //     title: "7.IP Contact",
      //     route: "/contact-list",
      //   });
      // }
      // if (item.cmd_route == "ip-price-list" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 8,
      //     title: "8.IP Price List",
      //     route: "/ip-price-list",
      //   });
      // }
      // if (item.cmd_route == "invoice-title" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 9,
      //     title: "9.Invoice Title",
      //     route: "/invoice-title",
      //   });
      // }
      // if (item.cmd_route == "miscellaneous-list" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 10,
      //     title: "10.Invoice Miscellaneous",
      //     route: "/miscellaneous-list",
      //   });
      // }
      // if (item.cmd_route == "im-master-placeofissue-list" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 11,
      //     title: "11.Immigration Place of issue",
      //     route: "/im-master-placeofissue-list",
      //   });
      // }
      // if (item.cmd_route == "im-master-workplaceofissue-list" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 12,
      //     title: "12.Immigration Work Place of issue",
      //     route: "/im-master-workplaceofissue-list",
      //   });
      // }
      // if (item.cmd_route == "leave-holiday" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 13,
      //     title: "13.Leave Holiday",
      //     route: "/leave-holiday",
      //   });
      // }
      // if (item.cmd_route == "training-list" && item.smd_view == 1) {
      //   this.checksubadmin = true;
      //   this.menus[1].items.push({
      //     index: 1,
      //     no: 14,
      //     title: "14.Training",
      //     route: "/training-list",
      //   });
      // }

      // // employee menu
      // if (item.cmd_route == "employee" && item.smd_view == 1) {
      //   this.checkemployee = true;
      //   this.menus[2].items.push({
      //     index: 2,
      //     title: "Employees",
      //     route: "/employee",
      //   });
      // }

      // // customer menu
      // if (item.cmd_route == "customer" && item.smd_view == 1) {
      //   this.checkcustomer = true;
      //   this.menus[3].items.push({
      //     index: 3,
      //     title: "Customers",
      //     route: "/customer",
      //   });
      // }

      // // config menu
      // if (item.cmd_route == "group-menu" && item.smd_view == 1) {
      //   this.checksubconfig = true;
      //   this.menus[4].items.push({
      //     index: 4,
      //     title: "1.Group Menu",
      //     route: "/group-menu",
      //   });
      // }

      // if (item.cmd_route == "menu-detail" && item.smd_view == 1) {
      //   this.checksubconfig = true;
      //   this.menus[4].items.push({
      //     title: "2.Menu Detail",
      //     route: "/menu-detail",
      //   });
      // }

      // if (item.cmd_route == "setting-group-menu" && item.smd_view == 1) {
      //   this.checksubconfig = true;
      //   this.menus[4].items.push({
      //     index: 4,
      //     title: "3.Setting Authorize",
      //     route: "/setting-group-menu",
      //   });
      // }

      // if (item.cmd_route == "mapping-keyword" && item.smd_view == 1) {
      //   this.checksubconfig = true;
      //   this.menus[4].items.push({
      //     index: 4,
      //     title: "4.IP Mapping Keyword",
      //     route: "/mapping-keyword",
      //   });
      // }

      // // time sheet menu
      // if (item.cmd_route == "my-activity" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "1.My Activity",
      //     route: "/my-activity",
      //   });
      // }
      // if (item.cmd_route == "new-activity" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "2.New Activity",
      //     route: "/new-activity",
      //   });
      // }
      // if (item.cmd_route == "my-time-sheet" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "3.My Time Sheet",
      //     route: "/my-time-sheet",
      //   });
      // }
      // if (item.cmd_route == "approve-time-sheet" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "4.Approve Time Sheet",
      //     route: "/approve-time-sheet",
      //   });
      // }
      // if (item.cmd_route == "activity-report" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "5.Activity Report",
      //     route: "/activity-report",
      //   });
      // }
      // if (item.cmd_route == "client-timesheet-report" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "6.Client Timesheet Report",
      //     route: "/client-timesheet-report",
      //   });
      // }
      // if (item.cmd_route == "employee-timesheet-report" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "7.Employee Timesheet Report",
      //     route: "/employee-timesheet-report",
      //   });
      // }
      // if (item.cmd_route == "attendant-report" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "8.Attendant Report",
      //     route: "/attendant-report",
      //   });
      // }
      // if (item.cmd_route == "summary-timesheets-activity-report" && item.smd_view == 1) {
      //   this.checksubtimesheet = true;
      //   this.menus[5].items.push({
      //     index: 5,
      //     title: "9.Summary TimeSheets Activity Report",
      //     route: "/summary-timesheets-activity-report",
      //   });
      // }
      // // Leave menu
      // if (item.cmd_route == "leave-list" && item.smd_view == 1) {
      //   this.checksubleave = true;
      //   this.menus[6].items.push({
      //     index: 6,
      //     title: "1.Leave Request",
      //     route: "/leave-list",
      //   });
      // }
      // if (item.cmd_route == "approver-leave" && item.smd_view == 1) {
      //   this.checksubleave = true;
      //   this.menus[6].items.push({
      //     index: 6,
      //     title: "2.Approve Leave",
      //     route: "/approver-leave",
      //   });
      // }
      // if (item.cmd_route == "leave-report" && item.smd_view == 1) {
      //   this.checksubleave = true;
      //   this.menus[6].items.push({
      //     index: 6,
      //     title: "3.Leave Report",
      //     route: "/leave-report",
      //   });
      // }

      // // So menu
      // if (item.cmd_route == "so-list" && item.smd_view == 1) {
      //   this.checksubso = true;
      //   this.menus[7].items.push({
      //     index: 7,
      //     title: "1.Sales Order",
      //     route: "/so-list",
      //   });
      // }

      // if (item.cmd_route == "sales-outstanding" && item.smd_view == 1) {
      //   this.checksubso = true;
      //   this.menus[7].items.push({
      //     index: 7,
      //     title: "2.Sales Outstanding",
      //     route: "/sales-outstanding",
      //   });
      // }

      // if (item.cmd_route == "sales-report" && item.smd_view == 1) {
      //   this.checksubso = true;
      //   this.menus[7].items.push({
      //     index: 7,
      //     title: "3.Sales Report",
      //     route: "/sales-report",
      //   });
      // }

      // // Advance menu
      // if (item.cmd_route == "advance-list" && item.smd_view == 1) {
      //   this.checksubadvance = true;
      //   this.menus[8].items.push({
      //     index: 8,
      //     title: "1.My Advance",
      //     route: "/advance-list",
      //   });
      // }

      // // if (item.cmd_route == "new-advance" && item.smd_view == 1) {
      // //   this.menus[6].items.push({
      // //     title: "Add Advance",
      // //     route: "/new-advance",
      // //   });
      // // }

      // if (item.cmd_route == "clearadvance-list" && item.smd_view == 1) {
      //   this.checksubadvance = true;
      //   this.menus[8].items.push({
      //     index: 8,
      //     title: "2.Clear Advance",
      //     route: "/clearadvance-list",
      //   });
      // }

      // if (item.cmd_route == "approve-advance-list" && item.smd_view == 1) {
      //   this.checksubadvance = true;
      //   this.menus[8].items.push({
      //     index: 8,
      //     title: "3.Approve Advance",
      //     route: "/approve-advance-list",
      //   });
      // }

      // // accountant menu
      // if (
      //   item.cmd_route == "account-pending-advance-list" &&
      //   item.smd_view == 1
      // ) {
      //   this.checksubaccount = true;
      //   this.menus[9].items.push({
      //     index: 9,
      //     title: "1.Pending Advance",
      //     route: "/account-pending-advance-list",
      //   });
      // }

      // if (
      //   item.cmd_route == "account-clear-advance-list" &&
      //   item.smd_view == 1
      // ) {
      //   this.checksubaccount = true;
      //   this.menus[9].items.push({
      //     index: 9,
      //     title: "2.Clear Advance",
      //     route: "/account-clear-advance-list",
      //   });
      // }

      // if (
      //   item.cmd_route == "account-reporting-advance-list" &&
      //   item.smd_view == 1
      // ) {
      //   this.checksubaccount = true;
      //   this.menus[9].items.push({
      //     index: 9,
      //     title: "3.Reporting Advance",
      //     route: "/account-reporting-advance-list",
      //   });
      // }

      // if (item.cmd_route == "invoice" && item.smd_view == 1) {
      //   this.checksubinvoice = true;
      //   this.menus[10].items.push({
      //     index: 10,
      //     no: 1,
      //     title: "1.Invoice",
      //     route: "/invoice",
      //   });
      // }
      // if (item.cmd_route == "adjust-invoice" && item.smd_view == 1) {
      //   this.checksubinvoice = true;
      //   this.menus[10].items.push({
      //     index: 10,
      //     no: 2,
      //     title: "2.Adjust Invoice",
      //     route: "/adjust-invoice",
      //   });
      // }
      // if (item.cmd_route == "receive" && item.smd_view == 1) {
      //   this.checksubinvoice = true;
      //   this.menus[10].items.push({
      //     index: 10,
      //     no: 3,
      //     title: "3.Receipt",
      //     route: "/receive",
      //   });
      // }
      // if (item.cmd_route == "adjust-receive" && item.smd_view == 1) {
      //   this.checksubinvoice = true;
      //   this.menus[10].items.push({
      //     index: 10,
      //     no: 4,
      //     title: "4.Adjust Tax Receive",
      //     route: "/adjust-receive",
      //   });
      // }
      // if (item.cmd_route == "credit-note" && item.smd_view == 1) {
      //   this.checksubinvoice = true;
      //   this.menus[10].items.push({
      //     index: 10,
      //     no: 5,
      //     title: "5.Credit Note",
      //     route: "/credit-note",
      //   });
      // }
      // if (item.cmd_route == "invoice-report" && item.smd_view == 1) {
      //   this.menus[10].items.push({
      //     index: 10,
      //     no: 6,
      //     title: "6.Invoice Report",
      //     route: "/invoice-report",
      //   });
      // }
      // if (item.cmd_route == "receive-report" && item.smd_view == 1) {
      //   this.menus[10].items.push({
      //     index: 10,
      //     no: 7,
      //     title: "7.Receive Report",
      //     route: "/receive-report",
      //   });
      // }

      // if (item.cmd_route == "immigration-master" && item.smd_view == 1) {
      //   this.checksubimmigration = true;
      //   this.menus[11].items.push({
      //     index: 11,
      //     title: "1.Immigration Master",
      //     route: "/immigration-master",
      //   });
      // }
      // if (item.cmd_route == "immigration-transaction" && item.smd_view == 1) {
      //   this.checksubimmigration = true;
      //   this.menus[11].items.push({
      //     index: 11,
      //     title: "2.Immigration Transaction",
      //     route: "/immigration-transaction",
      //   });
      // }
      // if (item.cmd_route == "d-document" && item.smd_view == 1) {
      //   this.checkddoc = true;
      //   this.menus[12].items.push({
      //     index: 12,
      //     title: "D-Document",
      //     route: "/d-document",
      //   });
      // }
      // if (item.cmd_route == "master-trademark-list" && item.smd_view == 1) {
      //   this.checksubiptm = true;
      //   this.menus[13].items.push({
      //     index: 13,
      //     title: "1.Master Trademark",
      //     route: "/master-trademark-list",
      //   });
      // }
      // if (
      //   item.cmd_route == "appointment-trademark-list" &&
      //   item.smd_view == 1
      // ) {
      //   this.checksubiptm = true;
      //   this.menus[13].items.push({
      //     index: 13,
      //     title: "2.Appointment Trademark",
      //     route: "/appointment-trademark-list",
      //   });
      // }
      // if (item.cmd_route == "import-tm" && item.smd_view == 1) {
      //   this.checksubiptm = true;
      //   this.menus[13].items.push({
      //     index: 13,
      //     title: "3.Import Trademark",
      //     route: "/import-tm",
      //   });
      // }
      // // if (item.cmd_route == "cover-report-tm" && item.smd_view == 1) {
      // //   this.checksubiptm = true;
      // //   this.menus[13].items.push({
      // //     index: 13,
      // //     title: "4.Cover Report",
      // //     route: "/cover-report-tm",
      // //   });
      // // }

      // if (item.cmd_route == "master-patent-list" && item.smd_view == 1) {
      //   this.checksubippt = true;
      //   this.menus[14].items.push({
      //     index: 14,
      //     title: "1.Master Patent",
      //     route: "/master-patent-list",
      //   });
      // }
      // if (item.cmd_route == "appointment-patent-list" && item.smd_view == 1) {
      //   this.checksubippt = true;
      //   this.menus[14].items.push({
      //     index: 14,
      //     title: "2.Appointment Patent",
      //     route: "/appointment-patent-list",
      //   });
      // }
      // // if (item.cmd_route == "cover-report-pt" && item.smd_view == 1) {
      //   if (item.cmd_route == "log-in-out-log-list" && item.smd_view == 1) {
      //     this.checksubippt = true;
      //     this.menus[15].items.push({
      //       index: 15,
      //       title: "1.Login Logs",
      //       route: "/log-in-out-log-list",
      //     });
      //   }
      //   if (item.cmd_route == "transaction-log-list" && item.smd_view == 1) {
      //     this.checksubippt = true;
      //     this.menus[15].items.push({
      //       index: 15,
      //       title: "2.Transaction Logs",
      //       route: "/transaction-log-list",
      //     });
      //   }
      //   this.checksubippt = true;
      //   this.menus[14].items.push({
      //     index: 14,
      //     title: "4.Cover Report",
      //     route: "/cover-report-pt",
      //   });
      // }

      // if (item.cmd_route == "clearadvance-add" && item.smd_view == 1) {
      //   this.menus[6].items.push({
      //     title: "Clear Advance",
      //     route: "/clearadvance-add",
      //   });
      // }
    });
    // sort 
    this.menus[1].items.sort((a,b) => {
      return a.no - b.no;
    })
    this.menus[10].items.sort((a,b) => {
      return a.no - b.no;
    })

    this.selectedMenu = this.menus.findIndex(
      (menu) => menu[2][1] == this.$route.path
    );

    this.selectedMenu = this.menus.findIndex(
      (menu) =>
        menu.items.findIndex((item) => item.route == this.$route.path) != -1
    );
    // alert(this.selectedMenu);

    if (this.checksubadmin == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Administrator") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checkemployee == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Employee") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checkcustomer == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Customer") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubconfig == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Config") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubtimesheet == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Time Sheet") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubleave == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Leave") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubso == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Sales Order") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubadvance == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Advance") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubaccount == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Accountant Advance") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubinvoice == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Invoice") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubimmigration == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Immigration") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checkddoc == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "D-Document") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubiptm == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "IP Trademark") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubippt == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "IP Patent") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
    if (this.checksubippt == false) {
      let getremoveindex = [];
      this.menus.forEach((itemmenu, index) => {
        if (itemmenu.title == "Logs") {
          getremoveindex.push(index);
        }
      });
      for (var i = getremoveindex.length - 1; i >= 0; i--)
        this.menus.splice(getremoveindex[i], 1);
    }
  },
  data() {
    return {
      checksubadmin: false,
      checkemployee: false,
      checkcustomer: false,
      checksubconfig: false,
      checksubtimesheet: false,
      checksubleave: false,
      checksubso: false,
      checksubadvance: false,
      checksubaccount: false,
      checksubinvoice: false,
      checksubimmigration: false,
      checksubiptm: false,
      checksubippt: false,
      checkddoc: false,
      isActive: false,
      items: [
        { text: "Real-Time", icon: "mdi-clock" },
        { text: "Audience", icon: "mdi-account" },
        { text: "Conversions", icon: "mdi-flag" },
      ],
      authorize: [],
      selectedMenu: 0,
      // menus: [
      //   ["mdi-apps-box", "Stock", "/stock"],
      //   ["mdi-chart-areaspline", "Report", "/report"],
      //   ["mdi mdi-account-multiple", "Employee", "/employee"],
      //   ["mdi mdi-account-multiple", "Customer", "/customer"],
      //   ["mdi mdi-account-convert", "Config", "/config"],
      //   ["mdi mdi-sitemap", "Menu setting", "/roleconfig"],
      // ],
      menus: [
        {
          index: 0,
          action: "mdi-apps-box",
          title: "Dashboard",
          items: [],
          route: "/dashboard",
        },
        // {
        //   index: 1,
        //   action: "mdi-clipboard-account",
        //   title: "Administrator",
        //   items: [],
        // },
        {
          index: 1,
          action: "mdi mdi-account-multiple",
          title: "Training",
          items: [],
          route: "/training-list",
        },
        // {
        //   index: 3,
        //   action: "mdi mdi-account",
        //   title: "Customer",
        //   items: [],
        //   route: "/customer",
        // },
        // {
        //   index: 4,
        //   action: "mdi mdi-sitemap",
        //   title: "Config",
        //   items: [],
        // },
        // {
        //   index: 5,
        //   action: "mdi-av-timer",
        //   title: "Time Sheet",
        //   items: [],
        // },
        // {
        //   index: 6,
        //   action: "mdi-run-fast",
        //   title: "Leave",
        //   items: [],
        // },

        // {
        //   index: 7,
        //   action: "mdi mdi-file",
        //   title: "Sales Order",
        //   items: [],
        // },
        // {
        //   index: 8,
        //   action: "mdi-message-draw",
        //   title: "Advance",

        //   items: [],
        // },
        // {
        //   index: 9,
        //   action: "mdi-note-text",
        //   title: "Accountant Advance",

        //   items: [],
        // },
        // {
        //   index: 10,
        //   action: "mdi-book-open",
        //   title: "Invoice",

        //   items: [],
        // },
        // {
        //   index: 11,
        //   action: "mdi-air-filter",
        //   title: "Immigration",

        //   items: [],
        // },
        // {
        //   index: 12,
        //   action: "mdi-book-edit-outline",
        //   title: "D-Document",

        //   items: [],
        //   route: "/d-document",
        // },
        // {
        //   index: 13,
        //   action: "mdi-book-edit-outline",
        //   title: "IP Trademark",
        //   items: [],
        // },
        // {
        //   index: 14,
        //   action: "mdi-book-edit-outline",
        //   title: "IP Patent",
        //   items: [],
        // },
        // {
        //   index: 15,
        //   action: "mdi-book-edit-outline",
        //   title: "Logs",
        //   items: [],
        // },
      ],
    };
  },
  watch: {
    $route(to, from) {
      // this.selectedMenu = this.menus.items.findIndex(
      //   (menu) => menu[2][1] == to.path
      // );

      this.selectedMenu = this.menus.findIndex(
        (menu) => menu.items.findIndex((item) => item.route == to.path) != -1
      );

      // alert(this.selectedMenu);
    },
  },
};
